import { HotkeyUtilities } from '../../../../../../../utilities/hotkeys/index.mjs';
import { headingLevels } from '../HeadingPlugin.mjs';
import { setHeading } from '../transforms/setHeading.mjs';

function headingHotKeyHandler(editor, event, defaultBlockType) {
  headingLevels.forEach(level => {
    const shortcut = `Ctrl+Alt+${level}`;
    const {
      altKey,
      ctrlKey,
      metaKey,
      shiftKey
    } = HotkeyUtilities.parseKeyboardShortcut(shortcut);
    const isHotKeyMatched = event.code.toLowerCase() === `Digit${level}`.toLowerCase() && event.altKey === altKey && event.ctrlKey === ctrlKey && event.metaKey === metaKey && event.shiftKey === shiftKey;
    if (isHotKeyMatched) {
      event.preventDefault();
      setHeading(editor, level, defaultBlockType);
    }
  });
}

export { headingHotKeyHandler };
